import api from './api';

export const postAutoCadastro = async params => {
  const { e } = params;
  try {
    const data = api.post('/usuario/register', e);
    return data;
  } catch (error) {
    return { error };
  }
};
